const isDev = process.env.NODE_ENV !== 'production';

type LogLevel = 'info' | 'warn' | 'error' | 'success';

const COLORS: Record<LogLevel, string> = {
  info: 'color: #60a5fa; font-weight: 600',
  warn: 'color: #fbbf24; font-weight: 600',
  error: 'color: #f87171; font-weight: 600',
  success: 'color: #34d399; font-weight: 600',
};

const ts = () => {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}.${String(d.getMilliseconds()).padStart(3, '0')}`;
};

export const analyticsLog = (
  level: LogLevel,
  event: string,
  data?: Record<string, unknown>
) => {
  if (!isDev) return;
  const label = `%c[GA4 ${ts()}] ${event}`;
  data
    ? console.log(label, COLORS[level], data)
    : console.log(label, COLORS[level]);
};
